export class DataTableEndpointDefinition
{
	constructor(
		{
			endpointRoute = '',
			endpointDisplayName = '',
			/**
			 * An object containing additional params to attach to the request
			 * @type {Object}
			 */
			endpointParams = null,
			enableSorting = true,
			initialSortColumn = 'id',
			initialSortDirection = 'asc',
			/**
			 * An array of objects. Objects must contain an 'id' and a 'value' param.
			 * @type {Array<Object>}
			 */
			advancedSearchParams = [],
			/**
			 * An array of {@link DataTableColumnDefinition }
			 * @type {Array<DataTableColumnDefinition>}
			 */
			columns = [],
			enableSearch = true,
			fullTextSearch = false,
			searchPlaceholder = '',
			showCheckboxes = false
		}
	) {
		this.endpointRoute = endpointRoute
		this.endpointDisplayName = endpointDisplayName
		this.endpointParams = endpointParams
		this.enableSorting = enableSorting
		this.initialSortColumn = initialSortColumn
		this.initialSortDirection = initialSortDirection
		this.advancedSearchParams = advancedSearchParams
		this.columns = columns
		this.enableSearch = enableSearch
		this.fullTextSearch = fullTextSearch
		this.searchPlaceholder = searchPlaceholder
		this.showCheckboxes = showCheckboxes
	}
}